import React from 'react';

export default function IconSearch({ ...props }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <title>Search</title>
      <path
        d="M8.33333 13.6667C11.555 13.6667 14.1667 11.055 14.1667 7.83333C14.1667 4.61167 11.555 2 8.33333 2C5.11167 2 2.5 4.61167 2.5 7.83333C2.5 11.055 5.11167 13.6667 8.33333 13.6667Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 17L12.5 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
